export default "__VITE_ASSET__CKZtg$Sq__"